import gql from 'graphql-tag';

export const REGISTRY_PROJECT_ARTIFACT_TYPES_QUERY = gql`
  query RegistryProjectArtifactTypes(
    $entityName: String!
    $projectName: String!
  ) {
    project(entityName: $entityName, name: $projectName) {
      id
      name
      artifactTypes(includeAll: true) {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`;
